import Page from "src/components/Report/Page";
import MiniChart from "./components/MiniChart";
import MiniSignalChart from "./components/MiniSignalChart";
import { useLocation } from "react-router-dom";

export default function Page19() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");

    let PI;
    if (JSON.parse(localStorage?.data)?.[jobId]?.PI) {
        PI = JSON.parse(localStorage?.data)?.[jobId]?.PI
    } else {
        PI = []
    }
    return (
        <Page pageNumber={18}>
            <div className="font-bold text-lg">
                شاخص های عملکردی (PI)
            </div>
            <p className="text-black text-justify">
                شاخص‌های عملکردی (Performance Indicators) معیارهایی هستند که میزان اثربخشی، کیفیت و بهره‌وری فرد در انجام وظایف شغلی را نشان می‌دهند. این شاخص‌ها شامل برنامه‌ریزی، مدیریت زمان، استفاده مؤثر از منابع، رعایت دستورالعمل‌ها و ارائه گزارش‌های تحلیلی می‌باشند. ارزیابی این شاخص‌ها مبنای سنجش عملکرد، پاداش‌دهی و ارتقاء شغلی است. درج این بخش به ایجاد نظام ارزیابی منسجم و هدفمند در سازمان کمک می‌کند.
            </p>
            <div className="flex flex-col">

                {
                    Object.keys(PI).sort(function (a, b) { return PI[b].value - PI[a].value }).map((key, index) => {
                        if (PI[key].value >= 1) {
                            return (
                                <div className="flex items-center gap-3 odd-color">
                                    <MiniSignalChart value={PI[key].value} />
                                    <div className=" px-2">{key}</div>
                                    {/* <div className="text-[13px]">{PI[key].desc}</div> */}
                                </div>
                            )
                        }
                    })
                }
            </div>
        </Page>
    )
}